import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledHeaderBox = styled(Box)(({ theme, variant }) => ({
  padding: '25px',
  paddingTop: '30px',
  paddingBottom: '30px',
  backgroundColor: 'white',
  borderBottom: '1px solid #ccc',
  maxWidth: '100%',
  ...(variant === 'twoRows'
    ? {
        display: 'block', 
      }
    : {
        display: 'flex',
        overflowX: 'auto',
      }),
}));

const HeaderFilterBox = ({ children, variant = 'base', sx = {}, ...props }) => {
  return (
    <StyledHeaderBox variant={variant} sx={sx} {...props}>
      {children}
    </StyledHeaderBox>
  );
};

export default HeaderFilterBox;
